import { render, staticRenderFns } from "./ceshi.vue?vue&type=template&id=73790e16&scoped=true&"
import script from "./ceshi.vue?vue&type=script&lang=js&"
export * from "./ceshi.vue?vue&type=script&lang=js&"
import style0 from "./ceshi.vue?vue&type=style&index=0&id=73790e16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73790e16",
  null
  
)

export default component.exports